import { css } from "@emotion/react";
import { UserContext } from "../../context/userContext";
import { useContext, useEffect, useState, useRef } from "react";

import {
  breakpoints,
  colors,
} from "@mytutor/shared-react-web-components/lib/theme";
import { Button } from "@mui/material";

const heroStyle = css`
  section {
    width: 100%;
    max-width: 1360px;
    margin: 0 auto;
    padding: 16px 20px;
    @media (min-width: ${breakpoints.tablet}px) {
      padding: 48px 20px;
    }
  }

  h1 {
    font-family: "BureauGrotesk", sans-serif;
    font-size: 2.25em;
    font-weight: 400;
    line-height: 1;
    margin: 0;
    @media (min-width: ${breakpoints.tablet}px) {
      font-size: 4em;
    }
  }

  p {
    line-height: 1.5;
    color: ${colors.neutral8};
    margin: 24px 0 10px;
  }

  .trust-pilot {
    width: fit-content;
    max-width: 230px;

    iframe {
      left: -7px
    }
  }
`;

const Hero = ({ title, description }) => {
  const { isAuthenticated } = useContext(UserContext);
  const [isMounted, setIsMounted] = useState(false);
  const ref = useRef(null);

  type TrustpilotWindow = Window & {
    Trustpilot: {
        loadFromElement: (element: HTMLElement, isMicro: boolean) => void;
    };
  };

  useEffect(() => {
    setIsMounted(true);
    const TrustPilotRef = ref.current;
    if (TrustPilotRef === null) return; 
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if ((window as unknown as TrustpilotWindow).Trustpilot) {
        (window as unknown as TrustpilotWindow).Trustpilot.loadFromElement(TrustPilotRef, true);
    }
  }, [isMounted]);

  
    return (
      <main css={heroStyle}>
        <section>
          <h1>{title}</h1>
          {isAuthenticated || <p data-cy="hero-description">{description}</p>}
          {isAuthenticated || <Button href="/get-started" sx={{margin: "16px 0"}}>Book a tutor</Button>}
          {isMounted &&  
          <div className="trust-pilot">
            <div
              ref={ref} // We need a reference to this element to load the TrustBox in the effect.
              className="trustpilot-widget" // Renamed this to className.
              data-locale="en-GB"
              data-template-id="5419b637fa0340045cd0c936"
              data-businessunit-id="591b1a030000ff0005a29184"
              data-style-height="22px"
              data-style-width="100%"
              data-theme="light"
            >
              Trustpilot
            </div>
          </div>
          }
        </section>
      </main>
    );
};


export default Hero;
